import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.defaults.timeout = 20000;

export function setAuthToken(token) {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
}

export function getStoredToken() {
  return localStorage.getItem("kipabiz_token");
}

export function storeToken(token) {
  if (token) localStorage.setItem("kipabiz_token", token);
  else localStorage.removeItem("kipabiz_token");
}

// Restore Authorization header on cold load (before React mounts)
setAuthToken(getStoredToken());
